module.exports = __webpack_public_path__ + "static/level-7-bg.bab62e8d.png";